import { takeLatest } from 'redux-saga/effects';
import { SAVE_DRAFT } from '../../actions/draft';
import { saveDraft } from './saveDraft';

export function* draftSagas() {
  yield takeLatest([SAVE_DRAFT], saveDraft);
}
